import React from 'react';
import Projects from '../components/Projects';

export default function ProjectPage() {
  return (
    <main>
     <Projects />
      {/* You could add more sections specific to the About page here */}
    </main>
  );
}